import { render, staticRenderFns } from "./OrderCancelationReason.vue?vue&type=template&id=77dfdba5&"
import script from "./OrderCancelationReason.vue?vue&type=script&lang=js&"
export * from "./OrderCancelationReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports